import React from "react";
import { School as SchoolIcon, Phone, Calendar } from "lucide-react";
import { MetaPill } from "./Pills";

export default function EntryCard({ entry, onOpen }) {
  return (
    <button
      type="button"
      onClick={onOpen}
      data-testid={`entry-card-${entry.id}`}
      className="block w-full text-left bg-white p-4 sm:p-5 rounded-2xl border border-sprouts-border shadow-soft mb-4 hover:shadow-card transition-shadow"
    >
      <div className="flex items-start gap-3 mb-2.5">
        <div className="flex-1 min-w-0">
          <h3 className="font-extrabold text-sprouts-text truncate">{entry.title}</h3>
          <p className="text-xs text-sprouts-muted mt-0.5">
            {entry.student_full_name} · Grade {entry.grade}-{entry.section}
          </p>
        </div>
        <span className="px-2.5 py-1 rounded-full text-[11px] font-extrabold bg-sprouts-lavender text-sprouts-primary">
          {entry.entry_type}
        </span>
      </div>
      <div className="flex flex-wrap gap-1.5 mb-1">
        <MetaPill Icon={SchoolIcon} text={`${entry.school_name} · ${entry.city}`} />
      </div>
      <div className="flex flex-wrap gap-1.5">
        <MetaPill Icon={Phone} text={entry.parent_contact} />
        <MetaPill Icon={Calendar} text={new Date(entry.created_at).toLocaleDateString()} />
      </div>
    </button>
  );
}
